import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { GroupedButtonConfig } from './grouped-button.interface';
import { ClickOutSideDirective } from '../../../../../ui-components/directives/clickOutSide.directive';

@Component({
  selector: 'lib-grouped-button',
  imports: [ClickOutSideDirective],
  templateUrl: './grouped-button.component.html',
  styleUrl: './grouped-button.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class GroupedButtonComponent {
  config = input.required<GroupedButtonConfig>();
  actionSelected = output<string>();
  showDropdown = signal<boolean>(false);

  toggleDropdown(): void {
    this.showDropdown.set(!this.showDropdown());
  }

  closeDropdown(): void {
    this.showDropdown.set(false);
  }

  handleActionClick(actionValue: string): void {
    this.actionSelected.emit(actionValue);
    this.closeDropdown();
  }

  onClickOutside(): void {
    this.closeDropdown();
  }
}
